export enum WsMessageTypes {
  SCENARIOS_CALCULATED = 'SCENARIOS_CALCULATED',
  ERROR = 'ERROR',
}
